import { ApolloError, useLazyQuery, useQuery } from '@apollo/client'
import { useEffect, useRef, useState } from 'react'
import { Flex, Box, Text, Card } from 'rebass/styled-components'
import styled from 'styled-components'
import { Skeleton } from '../../../components/loadingSkeleton/Skeleton'
import { GET_MEDICATIONS_ON_FILE, GET_MEDICATION_REMINDERS } from '../../../graphql/queries'
import { IGetMedicationRemindersInput, IGetMedicationRemindersOutput, IGetMedicationsOnFileInput, IGetMedicationsOnFileOutput, IMedicationOnFile } from '../../../graphql/types/queries/medications'
import { useIsVisible } from '../../../hooks/useIsVisible'
import * as uuid from 'uuid'

const Divider = styled(Box)`
  width: 100px;
  height: 1px;
  background-color: #C9C9C9;
  margin-top: 16px;
  margin-bottom: 16px;
`
interface IMedicationsProps {
  id: string
}

const OnFileLoading = () => {
  return (
    <Flex flexDirection={'column'} width='100%'>
      <Flex flexDirection={'column'} style={{ width: '100%', flex: 'initial', paddingLeft: '20px', borderLeft: '3px solid white' }} paddingY={'12px'} mb={4}>
        <Text fontWeight={600} fontSize='18px' mb={'18px 12px'}>Medications on file</Text>
        {[0, 1, 2].map(x => {
          return (
            <Flex flexDirection={'column'} key={`onFileLoading${x}`} marginX='12px'>
              <Skeleton width={80} />
              <Skeleton width={137} />
              <Divider />
            </Flex>
          )
        })}
      </Flex>
    </Flex>
  )
}

const OnFile = ({ data, error }: { data: IGetMedicationsOnFileOutput | undefined, error: ApolloError | undefined }) => {
const [medications, setMedications] = useState< Array<IMedicationOnFile & {
  id: string
} >>([])

useEffect(()=>{
  if(!data || !data.providerGetMedicationsForPatient){
    setMedications([])
  }else{
    const meds: Array<IMedicationOnFile & {
      id: string
    }> = []

    for (let index = 0; index < data.providerGetMedicationsForPatient.length; index++) {
      const element = data.providerGetMedicationsForPatient[index];
      meds.push({
        ...element,
        id: uuid.v4()
      })
      setMedications(meds)
    }
  }
},[])

useEffect(()=>{
  if(!data || !data.providerGetMedicationsForPatient){
    setMedications([])
  }else{
    const meds: Array<IMedicationOnFile & {
      id: string
    }> = []

    for (let index = 0; index < data.providerGetMedicationsForPatient.length; index++) {
      const element = data.providerGetMedicationsForPatient[index];
      meds.push({
        ...element,
        id: uuid.v4()
      })
      setMedications(meds)
    }
  }
}, [data])
  const [showActive, setShowActive] = useState<boolean>(true)
  return (
    <Flex flexDirection={'column'} width='100%'>
      <Flex flexDirection={'column'} style={{ width: '100%', flex: 'initial', paddingLeft: '20px', borderLeft: '3px solid white' }} paddingY={'12px'} mb={4}>
        <Flex flexDirection={['column', 'row', 'row']} mb={'18px 12px'} alignItems='baseline'>
          <Text fontWeight={600} fontSize='18px' marginRight={[0, '18px', '18px']} marginBottom={['12px', 0, 0]}>{`${!showActive ? 'Historical ' : ''}Medications`}</Text>
          <Text fontWeight={300} fontSize='14px' color={'#7092c7'} style={{ cursor: 'pointer' }} onClick={() => setShowActive(!showActive)}>{`${showActive ? `HISTORICAL (${(data?.providerGetMedicationsForPatient || []).filter(x => !x.isActive).length})` : `ACTIVE (${(data?.providerGetMedicationsForPatient || []).filter(x => x.isActive).length})`}`}</Text>
        </Flex>
        {error ? (
          <Text textAlign={'center'} color='#a2aab6'>An error occured</Text>
        ) : medications.filter(x => {
          if (!showActive) {
            return !x.isActive
          }
          return !!x.isActive
        }).length < 1 ? (
          <Text textAlign={'center'} color='#a2aab6'>No medications recorded</Text>) : (
          <Flex flexWrap={'wrap'} maxWidth={'600px'}>
            {!showActive ? (
              <>

                {medications.filter(x => {
                  return !x.isActive
                }).map(x => {
                  return (
                    <Flex flexDirection={'column'} key={`medInctive${x.id}`} p={2} flex='0 50%'>
                      <Flex flexDirection={'column'} p={2} style={{ borderLeft: '3px solid #f8a2945c' }}>
                     <Text fontWeight={500}>{x.medication}</Text>
                      <Text fontWeight={300}>{x.dose}{!!x.frequency? ` - ${x.frequency}`:''}</Text>
                      {!showActive && (
                        <Text opacity={0.7} fontSize={'12px'} mt={1} fontWeight={300} color='#59575d' >Stop Date {(x.events || []).find(y => y?.type === 'END')?.eventdate}</Text>
                      )}
                      </Flex>
                    </Flex>

                  )
                })}
              </>
            ) : (
              <>
                {medications.filter(x => {
                  return !!x.isActive
                }).map(x => {
                  return (
                    <Flex flexDirection={'column'} key={`medActive${x.id}`} p={2} flex='0 50%'>
                      <Flex flexDirection={'column'} p={2} style={{ borderLeft: '3px solid #f8a2945c' }}>
                      <Text fontWeight={500}>{x.medication}</Text>
                      <Text fontWeight={300}>{x.dose}{!!x.frequency? ` - ${x.frequency}`:''}</Text>
                      {!showActive && (
                        <Text opacity={0.7} fontSize={'12px'} mt={1} fontWeight={300} color='#59575d' >Stop Date {(x.events || []).find(y => y?.type === 'END')?.eventdate}</Text>

                      )}
                      </Flex>
                      {/* <Divider /> */}
                    </Flex>
                  )
                })}
              </>)}
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}

const RemindersLoading = () => {
  return (
    <Flex flexDirection={'column'} width='100%'>
      <Flex flexDirection={'column'} style={{ width: '100%', flex: 'initial', paddingLeft: '20px', borderLeft: '3px solid #B8D6F5' }} paddingY={'12px'} mb={4}>
        <Text fontWeight={600} fontSize='18px' mb={'18px 12px'}>Medications reminders set up in the app</Text>
        {[0, 1, 2].map(x => {
          return (
            <Flex key={`remindersLoading${x}`} width='100%' marginX='12px'>
              <Flex flexDirection={'column'} flex={1}>
                <Skeleton width={100} />
                <Skeleton width={137} />
                <Skeleton width={200} />
                <Divider />
              </Flex>
              <Skeleton width={100} />
            </Flex>
          )
        })}
      </Flex>
    </Flex>
  )
}

const Reminders = ({ data, error }: { data: IGetMedicationRemindersOutput | undefined, error: ApolloError | undefined }) => {
  return (
    <Flex flexDirection={'column'} width='100%'>
      <Flex flexDirection={'column'} style={{ width: '100%', flex: 'initial', paddingLeft: '20px', borderLeft: '3px solid #B8D6F5' }} paddingY={'12px'} mb={4}>
        <Text fontWeight={600} fontSize='18px' mb={'18px 12px'}>Medications reminders set up in the app</Text>
        {error ? (
          <Text textAlign={'center'} mt={4} color='#a2aab6'>Not a mobile user</Text>
        ) : !data || data.providerGetMedicationRemindersForPatient.length < 1 ? (
          <Text textAlign={'center'} mt={4} color='#a2aab6'>No medication reminders set</Text>) : (
          <>
            {data.providerGetMedicationRemindersForPatient.map(x => {
              return (
                <Flex key={x.id} width='100%' marginX='12px' p={2} style={{ borderLeft: '3px solid #f8a2945c' }} mt={2}>
                  <Flex flexDirection={'column'} flex={1}>
                    <Flex>
                      <Text fontWeight={500} mr={3}>{x.medicationName}</Text>

                      <Flex backgroundColor={x.isActive ? '#BCFFEB' : '#F0F5FD'} height={'30px'} paddingX={20} style={{ borderRadius: '8px' }}>
                        <Text>{x.isActive ? 'Active' : 'Disabled'}</Text>
                      </Flex>
                    </Flex>
                    <Text fontWeight={300}>{x.dose} - {x.frequency}</Text>
                    <Text fontWeight={300}>{`Reminder${x.times && x.times.length > 1 ? 's' : ''} set at: ${x.times?.join(', ')}`}</Text>
                    <Divider />
                  </Flex>
                </Flex>
              )
            })}
          </>
        )}
      </Flex>
    </Flex>
  )
}

export const Medications: React.FC<IMedicationsProps> = ({ id }) => {
  const ref = useRef<any>();
  const isVisible = useIsVisible(ref);
  const [load, { data, loading, error }] = useLazyQuery<IGetMedicationsOnFileOutput, IGetMedicationsOnFileInput>(GET_MEDICATIONS_ON_FILE, {
    variables: {
      id
    }
  })

  const [loadRem, { data: dataReminders, loading: loadingReminders, error: errorReminders }] = useLazyQuery<IGetMedicationRemindersOutput, IGetMedicationRemindersInput>(GET_MEDICATION_REMINDERS, {
    variables: {
      id
    }
  })

  useEffect(() => {
    if (!!isVisible) {
      load()
      loadRem()
    }
  }, [isVisible])
  return (
    <Flex ref={ref} flexDirection={'column'} width='100%' padding={'20px'}>
      {loading ? <OnFileLoading /> : <OnFile data={data} error={error} />}
      {loadingReminders ? <RemindersLoading /> : <Reminders data={dataReminders} error={errorReminders} />}
    </Flex>
  );
}